<template>
  <div class="level level-learning-path">
    <LevelRow
      @toggle="openLearningPath"
      :hasAccess="hasAccess"
      :contentType="content.type"
      :contentId="learningPathId"
      :status="isFinished"
      :statusText="statusText"
      :parentStatus="parentStatus"
      :title="title"
      :plansLink="plansLink"
      :isWatching="false"
      :details="learningPathDetails"
      :learningArea="content.learningArea"
      :progress="progress"
      @click.native="openLearningPath"
    >
    </LevelRow>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'
import LevelRow from '@/components/content/level/LevelRow.vue'

export default {
  name: 'LearningPathLevel',
  data() {
    return {
      isLoading: false,
    }
  },
  components: {
    LevelRow,
  },
  props: {
    learningPathId: {
      type: String,
      required: true,
    },
    parentStatus: {
      type: String,
      required: true,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    content: {
      type: Object,
      required: true,
    },
    plansLink: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    learningPathDetails() {
      return [this.content.instructor, this.content.duration]
    },
    progress() {
      return this.content.progress * 100
    },
    isFinished() {
      return this.content.progress === 1
        ? CONSTANTS.CONTENT_USER_STATUS.FINISHED
        : CONSTANTS.CONTENT_USER_STATUS.STARTED
    },
    statusText() {
      const isFinished = this.content.progress === 1
      const contentStatus = this.content.status
      if (
        contentStatus === CONSTANTS.CONTENT_USER_STATUS.STARTED &&
        !isFinished
      ) {
        return 'Resume'
      }
      if (isFinished) {
        return 'Restart'
      }
      return 'Start'
    },
  },
  methods: {
    async openLearningPath() {
      if (this.hasAccess) {
        this.$emit(
          'toggle-content',
          CONSTANTS.PLAYLIST_CONTENT_TYPES.LEARNING_PATH
        )
        this.$router.push(
          this.$buildContentLink('path', {
            id: this.learningPathId,
            slug: this.content.slug,
            learning_areas: [{ name: this.content.learningArea }],
          })
        )
      }
    },
  },
}
</script>
<style lang="scss">
.level-learning-path {
  .level__wrapper--enabled:hover {
    .level-row__action-icon__learning-path path {
      stroke: inherit;
      fill: var(--charcoal);
    }
  }
}
</style>
